import { addBreadcrumb } from "@/lib/error-tracking";
import type { AnalyticsProvider } from "../types";

export const errorBreadcrumbProvider: AnalyticsProvider = {
  name: "error-breadcrumb",
  track: (event, properties) =>
    addBreadcrumb({
      category: "analytics",
      message: event,
      data: properties,
      level: "info",
    }),
  identify: (userId) =>
    addBreadcrumb({
      category: "analytics",
      message: `identify: ${userId}`,
      level: "info",
    }),
  reset: () => {},
};
